"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
var connected_react_router_1 = require("connected-react-router");
var urls_1 = __importDefault(require("../urls"));
var apiUrls_1 = __importDefault(require("../../youwell-common/apiUrls"));
var Auth_1 = __importStar(require("../../youwell-common/Auth"));
var ReduxStoreHelper_1 = __importStar(require("../../youwell-common/ReduxStoreHelper"));
var constants_1 = require("../../youwell-common/constants");
var actions_1 = require("./actions");
var appSetup_1 = __importDefault(require("../appSetup"));
var reduxUtils_1 = require("../../youwell-common/reduxUtils");
var RequestStatusStore_1 = require("../../youwell-common/service/RequestStatusStore");
var PatientConsentStore_1 = require("./PatientConsentStore");
var storeHelper = new ReduxStoreHelper_1.default(actions_1.AUTH_ACTION_PREFIX);
var TOKEN_EXPIRED = 'TOKEN_EXPIRED';
var SUCCESS_GETPROFILE = 'SUCCESS_GETPROFILE';
var SUCCESS_SAVEPROFILE = 'SUCCESS_SAVEPROFILE';
var START_SESSION = 'START_SESSION';
var RESET_PASSWORD = 'RESET_PASSWORD';
var FORGOT_PASSWORD = 'FORGOT_PASSWORD';
var LOGOUT_ORG = 'LOGOUT_ORG';
exports.actionCreators = {
    clearError: function () { return function (dispatch) {
        dispatch((0, RequestStatusStore_1.clearErrors)());
        dispatch({
            type: ReduxStoreHelper_1.CLEAR_ERROR,
        });
    }; },
    loginWithCode: function (loginBody, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/codelogin"),
            method: 'POST',
            body: loginBody,
            completeAction: actions_1.AUTH_SUCCESS_LOGIN,
            onData: function (data) {
                Auth_1.default.setLoginInfo(data.loginLevel, data.sessionLifetime, Auth_1.authTypes.user);
            },
            options: options,
        });
    }; },
    loginWithAccessKey: function (loginBody, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/keylogin"),
            method: 'POST',
            body: loginBody,
            completeAction: actions_1.AUTH_SUCCESS_LOGIN,
            onData: function (data) {
                Auth_1.default.setLoginInfo(data.loginLevel, data.sessionLifetime, Auth_1.authTypes.user);
            },
            options: options,
        });
    }; },
    login: function (loginBody, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/login"),
            method: 'POST',
            body: loginBody,
            completeAction: actions_1.AUTH_SUCCESS_LOGIN,
            onData: function (data) {
                Auth_1.default.setLoginInfo(data.loginLevel, data.sessionLifetime, Auth_1.authTypes.user);
            },
            options: options,
        });
    }; },
    startNewSession: function (loginBody, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/start"),
            method: 'POST',
            body: loginBody,
            completeAction: actions_1.AUTH_SUCCESS_LOGIN,
            onData: function (data) {
                Auth_1.default.setLoginInfo(data.loginLevel, data.sessionLifetime, Auth_1.authTypes.user, options.useSessionWithoutLifetime);
            },
            options: options,
        });
    }; },
    logoutOrg: function (options) { return function (dispatch) {
        var _a;
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/logoutorg"),
            method: 'POST',
            requestId: LOGOUT_ORG,
            onData: function (data) {
                dispatch({ type: ReduxStoreHelper_1.LOGOUT, data: { authResponse: data, logoutReason: constants_1.logoutReasons.changeOrg } }); // Send Logout to empty all other state
                if (data && data.loginLevel) {
                    Auth_1.default.setLoginInfo(data.loginLevel, data.sessionLifetime, Auth_1.authTypes.orgSelect);
                }
                else {
                    Auth_1.default.deauthenticateUser();
                }
            },
            options: __assign(__assign({}, options), { redirect: (_a = options === null || options === void 0 ? void 0 : options.redirect) !== null && _a !== void 0 ? _a : "".concat(urls_1.default.login, "/").concat(urls_1.default.loginParts.selectOrg) }),
        });
    }; },
    selectOrg: function (orgId, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/selectorg/").concat(orgId),
            method: 'POST',
            completeAction: actions_1.AUTH_SUCCESS_LOGIN,
            onData: function (data) {
                Auth_1.default.setLoginInfo(data.loginLevel, data.sessionLifetime, Auth_1.authTypes.user);
            },
            options: options,
        });
    }; },
    logout: function (logoutReason, redirectAfterLogout) { return function (dispatch) {
        var loginLevel = Auth_1.default.getLoginLevel();
        var redirect = loginLevel !== constants_1.loginLevels.level4 ? redirectAfterLogout || urls_1.default.home : null;
        var redirectExternal = loginLevel === constants_1.loginLevels.level4 ? "".concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.route.oauth, "/logout/idporten") : null;
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/logout"),
            method: 'POST',
            body: {
                logoutReason: logoutReason,
            },
            requestId: ReduxStoreHelper_1.LOGOUT,
            onData: function () {
                Auth_1.default.deauthenticateUser();
                (0, reduxUtils_1.clearState)();
                dispatch({ type: ReduxStoreHelper_1.LOGOUT, data: { logoutReason: logoutReason } });
            },
            options: {
                redirect: redirect,
                redirectExternal: redirectExternal,
            },
            onError: function () {
                Auth_1.default.deauthenticateUser();
                (0, reduxUtils_1.clearState)();
                dispatch({ type: ReduxStoreHelper_1.LOGOUT, data: { logoutReason: logoutReason } });
                if (redirect) {
                    dispatch((0, connected_react_router_1.push)(redirect));
                }
                else if (redirectExternal) {
                    window.location.href = redirectExternal;
                }
            },
        });
    }; },
    getUserProfile: function (options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/profile"),
            completeAction: "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(SUCCESS_GETPROFILE),
            onUnauthorized: function () {
                Auth_1.default.deauthenticateUser();
                dispatch({ type: "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(TOKEN_EXPIRED) });
                dispatch((0, connected_react_router_1.push)(urls_1.default.login));
            },
            options: options,
        });
    }; },
    saveUserProfile: function (elementToSave, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/profile"),
            method: 'PUT',
            body: elementToSave,
            completeAction: "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(SUCCESS_SAVEPROFILE),
            options: options,
        });
    }; },
    forgotPassword: function (email, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/forgotPassword"),
            method: 'POST',
            requestId: "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(FORGOT_PASSWORD),
            body: {
                email: email,
            },
            options: options,
        });
    }; },
    resetPassword: function (body, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/resetPassword"),
            method: 'POST',
            requestId: "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(RESET_PASSWORD),
            body: body,
            options: options,
        });
    }; },
    startSession: function (body, options) { return function (dispatch) {
        storeHelper.fetch(dispatch, {
            url: "".concat(apiUrls_1.default.app.auth, "/ss"),
            requestId: "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(START_SESSION),
            method: 'POST',
            body: body,
            options: options,
        });
    }; },
    updateUserSettings: storeHelper.createUpdateActionCreator("".concat(apiUrls_1.default.app.auth, "/userSettings"), SUCCESS_GETPROFILE),
    updateUserData: storeHelper.createUpdateActionCreator("".concat(apiUrls_1.default.app.auth, "/userData"), SUCCESS_GETPROFILE),
};
var initialState = __assign(__assign({}, storeHelper.defaultInitialState), { profileData: null, clientConfig: (0, appSetup_1.default)(), logoutReason: null, hasUnansweredConsents: false });
var reducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    // Base reducer overloads
    switch (action.type) {
        case ReduxStoreHelper_1.LOGOUT: {
            var data = action.data;
            return __assign(__assign({}, initialState), { profileData: data.logoutReason === constants_1.logoutReasons.changeOrg ? (_a = data.authResponse) === null || _a === void 0 ? void 0 : _a.profile : null, logoutReason: data.logoutReason });
        }
        default: {
            var stateFromDefaultActions = storeHelper.defaultReducer(state, action, initialState);
            if (stateFromDefaultActions !== null) {
                return stateFromDefaultActions;
            }
        }
    }
    switch (action.type) {
        case "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(TOKEN_EXPIRED): {
            return __assign(__assign({}, initialState), { logoutReason: constants_1.logoutReasons.tokenExpired });
        }
        case actions_1.AUTH_SUCCESS_LOGIN: {
            var data = action.data;
            return __assign(__assign({}, state), { profileData: __assign(__assign({}, data.profile), { clientConfig: undefined }), 
                // @ts-ignore must fix types in appSetup()
                clientConfig: (0, appSetup_1.default)((_b = data.profile) === null || _b === void 0 ? void 0 : _b.clientConfig), logoutReason: null, hasUnansweredConsents: ((_d = (_c = data.profile) === null || _c === void 0 ? void 0 : _c.patientConsents) === null || _d === void 0 ? void 0 : _d.findIndex(function (c) { return !c.consentDate || (c.isRequired && !c.consent); })) > -1 });
        }
        case "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(SUCCESS_GETPROFILE): {
            var data = action.data;
            return __assign(__assign({}, state), { profileData: __assign(__assign({}, data), { clientConfig: undefined }), 
                // @ts-ignore must fix types in appSetup()
                clientConfig: (0, appSetup_1.default)(data === null || data === void 0 ? void 0 : data.clientConfig), hasUnansweredConsents: ((_e = data === null || data === void 0 ? void 0 : data.patientConsents) === null || _e === void 0 ? void 0 : _e.findIndex(function (c) { return !c.consentDate || (c.isRequired && !c.consent); })) > -1 });
        }
        case "".concat(actions_1.AUTH_ACTION_PREFIX, "/").concat(SUCCESS_SAVEPROFILE): {
            return __assign(__assign({}, state), { profileData: action.data });
        }
        case actions_1.USER_SENSOR_DELETED: {
            var data_1 = action.data;
            return __assign(__assign({}, state), { profileData: __assign(__assign({}, state.profileData), { sensors: (_g = (_f = state.profileData) === null || _f === void 0 ? void 0 : _f.sensors) === null || _g === void 0 ? void 0 : _g.filter(function (d) { return d.id !== data_1.id; }) }) });
        }
        case actions_1.USER_UPLOAD_PROFILEIMAGE: {
            return __assign(__assign({}, state), { profileData: __assign(__assign({}, state.profileData), { profileImageId: action.data }) });
        }
        case actions_1.USER_DELETE_PROFILEIMAGE: {
            return __assign(__assign({}, state), { profileData: __assign(__assign({}, state.profileData), { profileImageId: null }) });
        }
        case "".concat(PatientConsentStore_1.PatientConsentSlice.name, "/setConsentResponse"): {
            var payload_1 = action.payload;
            if (!((_h = state.profileData) === null || _h === void 0 ? void 0 : _h.patientConsents) || !(payload_1 === null || payload_1 === void 0 ? void 0 : payload_1.response)) {
                return state;
            }
            var patientConsents = state.profileData.patientConsents.map(function (c) { var _a; return (c.id === ((_a = payload_1.response) === null || _a === void 0 ? void 0 : _a.id) ? payload_1.response : c); });
            return __assign(__assign({}, state), { profileData: __assign(__assign({}, state.profileData), { patientConsents: patientConsents }), hasUnansweredConsents: patientConsents.findIndex(function (c) { return !c.consentDate || (c.isRequired && !c.consent); }) > -1 });
        }
        default: {
            return state || initialState;
        }
    }
};
exports.reducer = reducer;
